import React, { useState, useEffect } from 'react';
import DesistementPanel from './DesistementPanel';
import DesistementConfirm from './DesistementConfirm';
import { Container, Row, Col, CustomInput } from 'reactstrap';
import { getAssociationByIdPromise, getVenteByIdPromise } from '../../flux/actions/venteActions';

import { connect } from 'react-redux';
import { IDesistementContainerComponent, ITableClientLine } from '../../types/interfaces';
import LoadingPage from '../../pages/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExchangeAlt, faStoreAltSlash, faUserSlash } from '@fortawesome/free-solid-svg-icons'

const DesistementContainerComponent = ({
  enableDesistement,
  enableTransfert,
  enableChangementBien,
 }: IDesistementContainerComponent) => {
  const [selectedVente1, setSelectedVente1] = useState<any>(undefined);
  const [selectedVente2, setSelectedVente2] = useState<any>(undefined);
  const [isAssociation1, setIsAssociation1] = useState(false);
  const [isAssociation2, setIsAssociation2] = useState(false);
  const [vente1Loading, setVente1Loading] = useState(false);
  const [vente2Loading, setVente2Loading] = useState(false);
  const [consultationState1, setConsultationState1] = useState(1);
  const [consultationState2, setConsultationState2] = useState(1);
  const [clientsTableData1, setClientsTableData1] = useState<any[]>([]);
  const [clientsTableData2, setClientsTableData2] = useState<any[]>([]);
  const [encaissementsTableData2, setEncaissementsTableData2] = useState<any[]>([]);
  const [encaissementsTableData1, setEncaissementsTableData1] = useState<any[]>([]);
  const [tableAddedClientsLines1, setTableAddedClientsLines1] = useState<ITableClientLine[]>([]);
  const [tableAddedClientsLines2, setTableAddedClientsLines2] = useState<ITableClientLine[]>([]);
  const [asyncSelectKey, setAsyncSelectKey] = useState(0);
  const [duplicateClient1, setDuplicateClient1] = useState(false);
  const [duplicateClient2, setDuplicateClient2] = useState(false);
  const [totalWithdraw1, setTotalWithdraw1] = useState(false);
  const [totalWithdraw2, setTotalWithdraw2] = useState(false);
  const [transferToNew1, setTransferToNew1] = useState(false);
  const [transferToNew2, setTransferToNew2] = useState(false);
  const [changeBien1, setChangeBien1] = useState(false);
  const [changeBien2, setChangeBien2] = useState(false);
  const [selectedBien1, setSelectedBien1] = useState<any>(null);
  const [selectedBien2, setSelectedBien2] = useState<any>(null);
  const [selectedAssociation1, setSelectedAssociation1] = useState(undefined);
  const [selectedAssociation2, setSelectedAssociation2] = useState(undefined);
  const [isAssociationBien1, setIsAssociationBien1] = useState(false);
  const [isAssociationBien2, setIsAssociationBien2] = useState(false);
  // const [disableAssociation, setDisableAssociation] = useState(false);

  const selectVente1 = (e, isAssociation) => {
    setConsultationState1(1);
    setSelectedVente1(undefined);
    setVente1Loading(true);
    const getVenteCallback = (res, isAssociation) => {
      setIsAssociation1(isAssociation);
      console.log("callback hna", res);
      // setSelectedVente1(res ? {...res, ...(isAssociation ? {bien: res.contrat?.bien, PROJET: res.contrat?.PROJET} : {})} : undefined);
      setSelectedVente1(res ? (isAssociation ? {...(res.contrat || {}), associationPart: res} : res) : undefined);
      setVente1Loading(false);
    }
    if(isAssociation)
      getAssociationByIdPromise(e).then(res => getVenteCallback(res, isAssociation))
    else
      getVenteByIdPromise(e).then(res => getVenteCallback(res, isAssociation))
  }

  const selectVente2 = (e, isAssociation) => {
    setConsultationState2(1);
    setSelectedVente2(undefined);
    setVente2Loading(true);
    const getVenteCallback = (res, isAssociation) => {
      setIsAssociation2(isAssociation);
      setSelectedVente2(res ? (isAssociation ? {...(res.contrat || {}), associationPart: res} : res) : undefined);
      setVente2Loading(false);
    }
    if(isAssociation)
      getAssociationByIdPromise(e).then(res => getVenteCallback(res, isAssociation))
    else
      getVenteByIdPromise(e).then(res => getVenteCallback(res, isAssociation))
  }

  // const selectVente2 = e => {
  //   setConsultationState2(1);
  //   setVente2Loading(true);
  //   getVenteByIdPromise(e).then(res => {
  //     setSelectedVente2(res || undefined);
  //     setVente2Loading(false);
  //   });
  // }

  useEffect(() => {
    if(selectedVente1 && selectedVente2 && ((selectedVente1.associationPart && selectedVente2.associationPart) ? (selectedVente1.associationPart.id === selectedVente2.associationPart.id) : (selectedVente1.id === selectedVente2.id)))
      setSelectedVente2(undefined)
    setTotalWithdraw1(false);
    setTransferToNew1(false);
    setChangeBien1(false);
    setSelectedBien1(null);
  }, [selectedVente1])

  useEffect(() => {
    if(selectedVente1 && selectedVente2 && ((selectedVente1.associationPart && selectedVente2.associationPart) ? (selectedVente1.associationPart.id === selectedVente2.associationPart.id) : (selectedVente1.id === selectedVente2.id)))
      setSelectedVente1(undefined)
    setTotalWithdraw2(false);
    setTransferToNew2(false);
    setChangeBien2(false);
    setSelectedBien2(null);
  }, [selectedVente2])

  const clearAll = () => {
    setSelectedVente1(undefined);
    setSelectedVente2(undefined);
    setTableAddedClientsLines1([]);
    setTableAddedClientsLines2([]);
  }

  return (
    <>
      <Container>
        <Row className="justify-content-between">
          <Col xs="12">
            {(enableDesistement && enableTransfert && enableChangementBien) ? <h2 className="title"><FontAwesomeIcon icon={faExchangeAlt} />&nbsp;&nbsp;Transferts et Désistements</h2>
            : enableDesistement ? <h2 className="title"><FontAwesomeIcon icon={faUserSlash} />&nbsp;&nbsp;Désistements</h2>
            : enableTransfert ? <h2 className="title"><FontAwesomeIcon icon={faExchangeAlt} />&nbsp;&nbsp;Transferts</h2>
            : enableChangementBien ? <h2 className="title"><FontAwesomeIcon icon={faStoreAltSlash} />&nbsp;&nbsp;Changement de Bien</h2>
            : null}
          </Col>
        </Row>
      </Container>
      <DesistementPanel panelNumber={1} panelTitle={enableTransfert && !transferToNew1 ? "Bien 1" : "Bien"} selectVente={selectVente1} selectedVente={selectedVente1} setSelectedVente={setSelectedVente1} isAssociation={isAssociation1} venteLoading={vente1Loading} setVenteLoading={setVente1Loading} consultationState={consultationState1} setConsultationState={setConsultationState1} clientsTableData={clientsTableData1} setClientsTableData={setClientsTableData1} encaissementsTableData={encaissementsTableData1} setEncaissementsTableData={setEncaissementsTableData1} theOtherPanelClientsTransfers={clientsTableData2.filter(e => !!e.transfere)} theOtherPanelEncaissementsTransfers={encaissementsTableData2.filter(e => !!e.transfere)} tableAddedClientsLines={tableAddedClientsLines1} setTableAddedClientsLines={setTableAddedClientsLines1} asyncSelectKey={asyncSelectKey} setAsyncSelectKey={setAsyncSelectKey} duplicateClient={duplicateClient1} setDuplicateClient={setDuplicateClient1} totalWithdraw={totalWithdraw1} setTotalWithdraw={setTotalWithdraw1} transferToNew={transferToNew1} setTransferToNew={setTransferToNew1} changeBien={changeBien1} setChangeBien={setChangeBien1} selectedBien={selectedBien1} setSelectedBien={setSelectedBien1} selectedAssociation={selectedAssociation1} setSelectedAssociation={setSelectedAssociation1} isAssociationBien={isAssociationBien1} setIsAssociationBien={setIsAssociationBien1} enableDesistement={enableDesistement} enableTransfert={enableTransfert} enableChangementBien={enableChangementBien} />
      {!!(enableTransfert && !transferToNew1) && <>
        <div className="fullFlexCenter">
          <FontAwesomeIcon icon={faExchangeAlt} className="desistementMiddleIcon" />
        </div>
        <DesistementPanel panelNumber={2} panelTitle="Bien 2" selectVente={selectVente2} selectedVente={selectedVente2} setSelectedVente={setSelectedVente2} isAssociation={isAssociation2} venteLoading={vente2Loading} setVenteLoading={setVente2Loading} consultationState={consultationState2} setConsultationState={setConsultationState2} clientsTableData={clientsTableData2} setClientsTableData={setClientsTableData2} encaissementsTableData={encaissementsTableData2} setEncaissementsTableData={setEncaissementsTableData2} theOtherPanelClientsTransfers={clientsTableData1.filter(e => !!e.transfere)} theOtherPanelEncaissementsTransfers={encaissementsTableData1.filter(e => !!e.transfere)} tableAddedClientsLines={tableAddedClientsLines2} setTableAddedClientsLines={setTableAddedClientsLines2} asyncSelectKey={asyncSelectKey} setAsyncSelectKey={setAsyncSelectKey} duplicateClient={duplicateClient2} setDuplicateClient={setDuplicateClient2} totalWithdraw={totalWithdraw2} setTotalWithdraw={setTotalWithdraw2} transferToNew={transferToNew2} setTransferToNew={setTransferToNew2} changeBien={changeBien2} setChangeBien={setChangeBien2} selectedBien={selectedBien2} setSelectedBien={setSelectedBien2} selectedAssociation={selectedAssociation2} setSelectedAssociation={setSelectedAssociation2} isAssociationBien={isAssociationBien2} setIsAssociationBien={setIsAssociationBien2} enableDesistement={enableDesistement} enableTransfert={enableTransfert} enableChangementBien={enableChangementBien} />
      </>}
      <DesistementConfirm vente1={selectedVente1} vente2={selectedVente2} isAssociation1={isAssociation1} isAssociation2={isAssociation2} clients1={clientsTableData1} clients2={clientsTableData2} encaissements1={encaissementsTableData1} encaissements2={encaissementsTableData2} addedClients1={tableAddedClientsLines1} addedClients2={tableAddedClientsLines2} duplicateClient1={duplicateClient1} duplicateClient2={duplicateClient2} totalWithdraw1={totalWithdraw1} totalWithdraw2={totalWithdraw2} transferToNew1={transferToNew1} transferToNew2={transferToNew2} changeBien1={changeBien1} changeBien2={changeBien2} selectedBien1={selectedBien1} selectedBien2={selectedBien2} isAssociationBien1={isAssociationBien1} isAssociationBien2={isAssociationBien2} selectedAssociation1={selectedAssociation1} selectedAssociation2={selectedAssociation2} clearAll={clearAll} selectVente1={selectVente1} selectVente2={selectVente2} />
    </>
  );
};

export default connect(null, { })(DesistementContainerComponent);
